/* eComHQ split tests. Shared by every store; installed as assets/hq-split-test.js by shopify/split-test/apply.py.
   Puts each visitor in one group of every running test, shows that group's version of the page, and writes the visitor ID and
   groups to the cart so the order carries them. Tests are made in the dashboard's Split tests tab.
   When anything here fails the visitor sees the store as it is (control). How it works and how to remove it: shopify/split-test/README.md. */
(function () {
  'use strict';
  var ENDPOINT = 'https://admin.ecomhq.net/.netlify/functions/';
  var VID = 'hq_vid', GROUPS = 'hq_groups', SESSION = 'hq_sess', CONFIG = 'hq_cfg', INTERNAL = 'hq_int', PREVIEW = 'hq_preview', CART = 'hq_cart', LOOP = 'hq_redirects', OUTBOX = 'hq_out', PRICED = 'hq_priced';
  var YEAR = 365 * 86400, IDLE_MS = 30 * 60000, REFRESH_MS = 5 * 60000, WAIT_MS = 2500, HIDE_MS = 3000, FIELD = 160, HOLD_MS = 1500, DAY_MS = 86400000;

  /* ---- Rules. Plain functions with no browser in them; shopify/split-test/test.mjs runs them in Node. ---- */

  // FNV-1a with a final mix, so IDs that differ in one character land far apart.
  function hash32(text) {
    var h = 2166136261, i;
    for (i = 0; i < text.length; i++) { h ^= text.charCodeAt(i); h = Math.imul(h, 16777619); }
    h ^= h >>> 16; h = Math.imul(h, 2246822507); h ^= h >>> 13; h = Math.imul(h, 3266489909); h ^= h >>> 16;
    return h >>> 0;
  }
  function unit(text) { return hash32(text) / 4294967296; }

  // "<seconds, base 36>-<16 random characters>". The time is when this browser was first seen, so new and returning need no second value.
  var LETTERS = '0123456789abcdefghijklmnopqrstuvwxyz';
  function newId(now, bytes) {
    var out = '', i;
    for (i = 0; i < 16; i++) out += LETTERS.charAt(bytes[i] % 36);
    return Math.floor(now / 1000).toString(36) + '-' + out;
  }
  function validId(id) { return typeof id === 'string' && /^[0-9a-z]{5,8}-[0-9a-z]{16}$/.test(id); }
  function firstSeen(id) { return parseInt(id.split('-')[0], 36) * 1000; }

  // The group for one visitor in one test, or null when the visitor is outside the test's traffic allocation.
  // The same ID and test always give the same answer, on any device and on the server.
  function pick(vid, test) {
    if (unit(vid + '|' + test.id + '|a') * 100 >= test.alloc) return null;
    var total = 0, sum = 0, i, at;
    for (i = 0; i < test.groups.length; i++) total += test.groups[i].w;
    if (!(total > 0)) return null;
    at = unit(vid + '|' + test.id + '|g') * total;
    for (i = 0; i < test.groups.length; i++) { sum += test.groups[i].w; if (at < sum) return test.groups[i].id; }
    return test.groups[test.groups.length - 1].id;
  }

  // Saved groups: "testid.group_testid.group". Short enough for a cookie and a cart attribute.
  function parseGroups(text) {
    var out = {};
    String(text || '').split('_').forEach(function (part) { var m = /^([a-f0-9]{12})\.([a-z0-9]{1,12})$/.exec(part); if (m) out[m[1]] = m[2]; });
    return out;
  }
  function formatGroups(map) { return Object.keys(map).sort().map(function (id) { return id + '.' + map[id]; }).join('_'); }

  function normal(path) {
    path = String(path == null ? '/' : path).replace(/^https?:\/\/[^/]+/i, '').split('#')[0].split('?')[0].toLowerCase();
    if (path.charAt(0) !== '/') path = '/' + path;
    if (path.length > 1) path = path.replace(/\/+$/, '');
    return path || '/';
  }
  // No patterns means every page. A pattern is a path; * stands for anything.
  function matchPath(patterns, path) {
    if (!patterns || !patterns.length) return true;
    path = normal(path);
    for (var i = 0; i < patterns.length; i++) {
      var p = normal(patterns[i]);
      if (p.indexOf('*') < 0 ? p === path : new RegExp('^' + p.replace(/[.+?^${}()|[\]\\]/g, '\\$&').replace(/\*/g, '.*') + '$').test(path)) return true;
    }
    return false;
  }

  function clean(value) { return String(value == null ? '' : value).replace(/\s+/g, ' ').trim().slice(0, FIELD); }
  function lower(value) { return clean(value).toLowerCase(); }

  var SITES = [['facebook', /(^|\.)(facebook\.com|fb\.com|fb\.me|messenger\.com)$|^(fb|facebook|meta)$/], ['instagram', /(^|\.)instagram\.com$|^(ig|instagram)$/], ['tiktok', /(^|\.)tiktok\.com$|^tiktok$/],
    ['twitter', /(^|\.)(twitter\.com|x\.com)$|^t\.co$|^(twitter|x)$/], ['youtube', /(^|\.)(youtube\.com|youtu\.be)$|^youtube$/], ['pinterest', /(^|\.)pinterest\.[a-z.]+$|^pinterest$/], ['snapchat', /(^|\.)snapchat\.com$|^snapchat$/],
    ['reddit', /(^|\.)reddit\.com$|^reddit$/], ['linkedin', /(^|\.)(linkedin\.com|lnkd\.in)$|^linkedin$/],
    ['google', /(^|\.)google\.[a-z.]+$|^(google|adwords)$/], ['bing', /(^|\.)bing\.com$|^bing$/], ['yahoo', /(^|\.)yahoo\.[a-z.]+$|^yahoo$/], ['duckduckgo', /(^|\.)duckduckgo\.com$|^duckduckgo$/]];
  var SOCIAL = { facebook: 1, instagram: 1, tiktok: 1, twitter: 1, youtube: 1, pinterest: 1, snapchat: 1, reddit: 1, linkedin: 1 }, SEARCH = { google: 1, bing: 1, yahoo: 1, duckduckgo: 1 };
  function siteOf(name) {
    name = lower(name).replace(/^www\./, '').replace(/^(m|l|lm|mobile)\./, '');
    if (!name) return '';
    for (var i = 0; i < SITES.length; i++) if (SITES[i][1].test(name)) return SITES[i][0];
    return name;
  }
  // Where a visit came from, in the dashboard's words. `a` has the landing address's tags and click IDs and the referring host.
  function classify(a) {
    var us = lower(a.us), um = lower(a.um), ref = lower(a.ref), own = lower(a.host);
    if (ref && own && (ref === own || ref.replace(/^www\./, '') === own.replace(/^www\./, ''))) ref = '';
    var site = siteOf(us) || siteOf(ref), paid = /(^|[^a-z])(cpc|ppc|paid|paidsocial|paid_social|ads?)([^a-z]|$)/.test(um), ch;
    if (/^(sms|text)$/.test(um) || /^(sms|postscript|attentive)$/.test(us)) ch = 'sms';
    else if (/e-?mail|newsletter/.test(um) || /^(klaviyo|email|newsletter|mailchimp|omnisend)$/.test(us)) ch = 'email';
    else if (/affiliate|partner|influencer/.test(um)) ch = 'affiliate';
    else if (/shopping|pla|pmax/.test(um)) ch = 'paid_shopping';
    else if (a.gclid || a.msclkid) ch = 'paid_search';
    else if (SEARCH[site] && paid) ch = 'paid_search';
    // Our ads carry utm_source, the ad set as utm_medium and the campaign; an untagged social link is someone sharing it.
    else if (SOCIAL[site] && (paid || a.uc || (us && (a.fbclid || a.ttclid)))) ch = 'paid_social';
    else if (SOCIAL[site]) ch = 'organic_social';
    else if (SEARCH[site] && !us) ch = 'organic_search';
    else if (site) ch = 'referral';
    else ch = 'direct';
    return { ch: ch, site: site || '(direct)' };
  }

  // Does this session enter the test? Sources are one choice: any ticked channel or site lets the visit in.
  function eligible(tg, s) {
    if (!tg) return true;
    var channels = tg.channels || [], sites = tg.sites || [], countries = tg.countries || [];
    if (tg.device && tg.device !== 'all' && tg.device !== (s.dev === 'm' ? 'mobile' : 'desktop')) return false;
    if (tg.visitor && tg.visitor !== 'all' && (tg.visitor === 'new') !== !!s.nw) return false;
    if ((channels.length || sites.length) && channels.indexOf(s.ch) < 0 && sites.indexOf(s.site) < 0) return false;
    if (countries.length && countries.indexOf(String(s.co || '').toUpperCase()) < 0) return false;
    if (tg.utmSource && lower(tg.utmSource) !== lower(s.us)) return false;
    if (tg.utmMedium && lower(tg.utmMedium) !== lower(s.um)) return false;
    if (tg.utmCampaign && lower(tg.utmCampaign) !== lower(s.uc)) return false;
    if (tg.landingPage && !matchPath([tg.landingPage], s.lp)) return false;
    if ((tg.currencies || []).length && tg.currencies.indexOf(String(s.cur || '').toUpperCase()) < 0) return false;
    return true;
  }

  // Which cart lines are not the variant this browser is shown, and what each becomes. `want` is a product's own variant to this
  // browser's group's duplicate of it; `origin` is every known duplicate to the variant it copies. Each line is moved by itself: the new
  // variant is added with the line's quantity, properties and selling plan, and only then is the old line taken out. (A cart update by
  // variant ID cannot tell two lines of one variant apart: on a live store it merged a plain line into one with properties.)
  function cartPlan(items, want, origin, hold) {
    var moves = [];
    (items || []).forEach(function (line) {
      var x = String(line.variant_id), o = origin[x] || x, target = String(want[o] || o);
      // `hold`: products whose group price this visitor has not been shown yet. Their lines are left as they are, either way.
      if (target === x || (hold && hold[o])) return;
      moves.push({ key: line.key, id: target, quantity: line.quantity, properties: line.properties || {}, plan: line.selling_plan_allocation && line.selling_plan_allocation.selling_plan ? line.selling_plan_allocation.selling_plan.id : null });
    });
    return { moves: moves, any: moves.length > 0 };
  }

  // Mutually exclusive tests are offered to a visitor in an order drawn from their ID, so each test of a set comes first for an equal share of visitors.
  function drawOrder(vid, ids) { return ids.slice().sort(function (a, b) { return unit(vid + '|' + a + '|x') - unit(vid + '|' + b + '|x') || (a < b ? -1 : 1); }); }

  // A visit ends after 30 minutes without a page, or when the visitor arrives again through a different tagged link.
  function sameVisit(s, now, arrival) {
    if (!s || typeof s !== 'object' || !s.id || !(now - s.l < IDLE_MS) || now < s.l - 60000) return false;
    return !arrival.us && !arrival.click ? true : lower(arrival.us) === lower(s.us) && lower(arrival.uc) === lower(s.uc) && lower(arrival.um) === lower(s.um);
  }

  /* Price tests. `map` is {"<variant id>": {v: "<duplicate variant id>", from: cents, was: cents|null, p: cents, c: cents|null}}. */
  function priceMaps(map) {
    var money = {}, pct = {}, ids = {}, clash = false;
    var put = function (table, from, to) { if (from == null || to == null) return; if (table[from] != null && table[from] !== to) clash = true; table[from] = to; };
    Object.keys(map || {}).forEach(function (id) {
      var m = map[id];
      ids[id] = String(m.v);
      put(money, m.from, m.p);
      if (m.was != null) {
        var c = m.c == null ? m.was : m.c;
        put(money, m.was, c);
        if (m.was > m.from && c > m.p) { put(money, m.was - m.from, c - m.p); put(pct, Math.round((m.was - m.from) / m.was * 100), Math.round((c - m.p) / c * 100)); }
      }
    });
    // A new amount that is also one of the product's own amounts would be swapped a second time on the next look at the page.
    Object.keys(money).forEach(function (from) { var to = money[from]; if (to !== +from && money[to] != null && money[to] !== to) clash = true; });
    return { money: money, pct: pct, ids: ids, clash: clash };
  }
  // Every amount in the text that is one of the product's own (price, compare-at, saving) becomes the group's amount, in the same form.
  function swapText(text, maps) {
    var out = String(text).replace(/\$\s?(\d{1,3}(?:,\d{3})+|\d+)(\.\d{2})?(?![\d.]*\d)/g, function (all, whole, cents) {
      var from = parseInt(whole.replace(/,/g, ''), 10) * 100 + (cents ? parseInt(cents.slice(1), 10) : 0), to = maps.money[from];
      if (to == null || to === from) return all;
      var dollars = Math.floor(to / 100), rest = to % 100, body = whole.indexOf(',') >= 0 ? dollars.toLocaleString('en-US') : String(dollars);
      return all.charAt(1) === ' ' ? '$ ' + body + (cents || rest ? '.' + ('0' + rest).slice(-2) : '') : '$' + body + (cents || rest ? '.' + ('0' + rest).slice(-2) : '');
    });
    if (/save|off|discount/i.test(out)) out = out.replace(/(\d{1,2})(\s?%)/g, function (all, n, sign) { var to = maps.pct[+n]; return to == null ? all : to + sign; });
    return out;
  }
  // The variant an add to cart names, swapped for this group's duplicate. Handles the bodies themes send: JSON, form text, FormData, URLSearchParams.
  function swapAdd(body, ids) {
    var one = function (id) { return ids[String(id)] || id; };
    try {
      if (typeof body === 'string') {
        var t = body.replace(/^\s+/, '');
        if (t.charAt(0) === '{') {
          var json = JSON.parse(t);
          if (json.id != null) json.id = one(json.id);
          if (Array.isArray(json.items)) json.items.forEach(function (item) { if (item && item.id != null) item.id = one(item.id); });
          return JSON.stringify(json);
        }
        return body.replace(/(^|&)(id|items(?:%5B|\[)\d*(?:%5D|\])(?:%5B|\[)id(?:%5D|\]))=(\d+)/g, function (all, lead, key, id) { return lead + key + '=' + one(id); });
      }
      if (body && typeof body.forEach === 'function' && typeof body.set === 'function') {
        var changes = [];
        body.forEach(function (value, key) { if ((key === 'id' || /^items\[\d*\]\[id\]$/.test(key)) && ids[String(value)]) changes.push([key, ids[String(value)]]); });
        changes.forEach(function (c) { body.set(c[0], c[1]); });
      }
    } catch (e) {}
    return body;
  }

  // An add to cart with cart attributes joined to it, in the forms themes send. Shopify takes attributes in the add itself, so the
  // cart names this browser's price group from the first moment it holds the line.
  function addAttrs(body, attrs) {
    var keys = Object.keys(attrs || {});
    if (!keys.length) return body;
    try {
      if (typeof body === 'string') {
        var t = body.replace(/^\s+/, '');
        if (t.charAt(0) === '{') {
          var json = JSON.parse(t);
          if (!json.attributes || typeof json.attributes !== 'object') json.attributes = {};
          keys.forEach(function (k) { json.attributes[k] = attrs[k]; });
          return JSON.stringify(json);
        }
        return body + keys.map(function (k) { return '&' + encodeURIComponent('attributes[' + k + ']') + '=' + encodeURIComponent(attrs[k]); }).join('');
      }
      if (body && typeof body.forEach === 'function' && typeof body.set === 'function') keys.forEach(function (k) { body.set('attributes[' + k + ']', attrs[k]); });
    } catch (e) {}
    return body;
  }
  /* Pricing tests charged by the store's cart transform function (test.fn): one product, and the cart says which price to charge. */
  // The groups whose price this browser has been shown, as the cart attribute _hq_px carries them.
  function shownPrices(entries, shown) {
    var out = {};
    (entries || []).forEach(function (e) { if (e.test.type === 'price' && e.test.fn && e.group.map && (shown || {})[e.test.id] === e.group.id) out[e.test.id] = e.group.id; });
    return formatGroups(out);
  }
  // Cart lines that should be charged this browser's price, because the cart names the group, and are charged another.
  function mischarged(items, entries, named) {
    var out = [];
    (entries || []).forEach(function (e) {
      if (e.test.type !== 'price' || !e.test.fn || !e.group.map || (named || {})[e.test.id] !== e.group.id) return;
      (items || []).forEach(function (line) {
        var m = e.group.map[String(line.variant_id)];
        if (m && !line.selling_plan_allocation && line.price !== m.p) out.push({ test: e.test.id, group: e.group.id, charged: line.price, shown: m.p });
      });
    });
    return out;
  }
  // The compare-at amounts alone: with the function a cart prints the charged price itself, and only the struck-through price is the product's own.
  function compareMaps(map) {
    var money = {};
    Object.keys(map || {}).forEach(function (id) { var m = map[id]; if (m.was != null && m.c != null && m.c !== m.was) money[m.was] = m.c; });
    return { money: money, pct: {} };
  }

  if (typeof window === 'undefined') {
    if (typeof module === 'object' && module) module.exports = { addAttrs: addAttrs, shownPrices: shownPrices, mischarged: mischarged, compareMaps: compareMaps, hash32: hash32, unit: unit, drawOrder: drawOrder, cartPlan: cartPlan, newId: newId, validId: validId, firstSeen: firstSeen, pick: pick, parseGroups: parseGroups, formatGroups: formatGroups, normal: normal, matchPath: matchPath, siteOf: siteOf, classify: classify, eligible: eligible, sameVisit: sameVisit, priceMaps: priceMaps, swapText: swapText, swapAdd: swapAdd };
    return;
  }

  /* ---- The page. Everything below is inside one try: a failure here must never reach the storefront. ---- */
  var styles = [];
  var unhide = function () { styles.splice(0).forEach(function (s) { try { s.parentNode.removeChild(s); } catch (e) {} }); };
  try {
    if (window.HQSplit) return;
    var me = document.currentScript, shop = (me && me.getAttribute('data-shop')) || (window.Shopify && window.Shopify.shop) || '';
    if (me && me.getAttribute('data-endpoint')) ENDPOINT = me.getAttribute('data-endpoint');
    var api = window.HQSplit = { version: 1, ready: false, vid: null, session: null, groups: {}, active: [], preview: null, exposed: {}, errors: [], sync: function () {} };
    // The theme editor shows the store as it is.
    if (!shop || (window.Shopify && window.Shopify.designMode)) { api.ready = true; return; }

    var storage = function (name) { try { return window[name]; } catch (e) { return null; } };
    var local = storage('localStorage'), session = storage('sessionStorage');
    var get = function (store, key) { try { return store ? store.getItem(key) : null; } catch (e) { return null; } };
    var set = function (store, key, value) { try { if (store) { if (value === null) store.removeItem(key); else store.setItem(key, value); } } catch (e) {} };
    var cookie = function (key) { try { var m = document.cookie.match(new RegExp('(?:^|; )' + key + '=([^;]*)')); return m ? decodeURIComponent(m[1]) : ''; } catch (e) { return ''; } };
    var bake = function (key, value, seconds) { try { document.cookie = key + '=' + encodeURIComponent(value) + '; Max-Age=' + seconds + '; Path=/; SameSite=Lax' + (location.protocol === 'https:' ? '; Secure' : ''); } catch (e) {} };
    var json = function (text) { try { return JSON.parse(text); } catch (e) { return null; } };
    var fail = function (where, e) { try { api.errors.push(where + ': ' + String((e && e.message) || e).slice(0, 160)); } catch (x) {} };

    var now = Date.now(), q = new URLSearchParams(location.search), path = location.pathname;
    var root = '/';
    try { root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; } catch (e) {}

    // ?hq_internal=1 marks this browser as ours for good (staff, agents, checks); its visits are left out of every result. ?hq_internal=0 undoes it.
    if (q.has('hq_internal')) {
      var on = q.get('hq_internal') !== '0';
      set(local, INTERNAL, on ? '1' : null); bake(INTERNAL, on ? '1' : '', on ? YEAR : 0);
    }
    var internal = get(local, INTERNAL) === '1' || cookie(INTERNAL) === '1';
    var bot = !!navigator.webdriver || /bot|crawl|spider|slurp|headless|lighthouse|pagespeed|gtmetrix|pingdom|prerender|facebookexternalhit|preview/i.test(navigator.userAgent || '');

    // ?hq_preview=<test id>.<group id> shows that group for the rest of this tab's visit, whatever the test's state. Nothing is counted. ?hq_preview=off ends it.
    var preview = null;
    if (q.has('hq_bar')) set(session, PREVIEW + '_bar', q.get('hq_bar') === '0' ? null : '1');
    if (q.has('hq_preview')) set(session, PREVIEW, /^[a-f0-9]{12}\.[a-z0-9]{1,12}$/.test(q.get('hq_preview')) ? q.get('hq_preview') : null);
    if (get(session, PREVIEW)) { var pv = get(session, PREVIEW).split('.'); preview = api.preview = { test: pv[0], group: pv[1] }; }

    // Our own requests use XMLHttpRequest with a mark, so theme scripts that listen to fetch (the cart drawer) never see them and this script never counts them as the theme's.
    var request = function (method, url, body, done, ms) {
      try {
        var x = new XMLHttpRequest(), finished = false, finish = function (value) { if (!finished) { finished = true; done(value); } };
        x._hq = true;
        x.open(method, url, true);
        x.timeout = ms || 8000;
        x.setRequestHeader('Accept', 'application/json');
        if (body) x.setRequestHeader('Content-Type', url.indexOf(ENDPOINT) === 0 ? 'text/plain' : 'application/json');
        x.onloadend = function () { var out = null; try { if (x.status >= 200 && x.status < 300) out = JSON.parse(x.responseText); } catch (e) {} finish(out); };
        x.send(body ? JSON.stringify(body) : null);
      } catch (e) { done(null); }
    };

    /* ---- Who this is ---- */
    var vid = cookie(VID) || get(local, VID), minted = false;
    if (!validId(vid)) vid = null;
    var groups = parseGroups(get(local, GROUPS) || cookie(GROUPS));
    // A preview leaves no trace: no visitor ID, no group and no visit are written while a tab is previewing.
    var keepIds = function () { if (preview) return; set(local, VID, vid); bake(VID, vid, YEAR); var text = formatGroups(groups); set(local, GROUPS, text || null); bake(GROUPS, text, text ? YEAR : 0); };

    // A link in one of our emails names the visitor it was written for: ?hq_vid=<id>&hq_groups=<test.group_test.group>. This browser
    // becomes that visitor and takes those groups, so the price the email printed is the price shown here, on any device. ?hq_list=1 is
    // on a link from an email that printed a product's own price to someone in no group of a pricing test: this browser is kept out of
    // the pricing tests running now, so that price is the one it goes on seeing. The dashboard writes all three (`splitPrices`).
    var given = {}, listed = q.get('hq_list') === '1';
    if (validId(q.get('hq_vid'))) {
      if (q.get('hq_vid') !== vid) { vid = q.get('hq_vid'); groups = {}; set(local, SESSION, null); api.linked = true; }
      given = parseGroups(q.get('hq_groups'));
      Object.keys(given).forEach(function (id) { groups[id] = given[id]; });
      keepIds();
    }
    if (q.has('hq_vid') || q.has('hq_groups') || q.has('hq_list')) {
      // Taken out of the address so a copied link does not hand this visitor's ID to someone else.
      try { var bare = new URL(location.href); ['hq_vid', 'hq_groups', 'hq_list'].forEach(function (k) { bare.searchParams.delete(k); }); history.replaceState(history.state, '', bare.pathname + bare.search + bare.hash); } catch (e) {}
    }

    /* ---- Which tests are running. The page carries a copy (the shop metafield hq_split.tests, printed by the layout); the dashboard is asked
       in the background so a pause reaches a browser whose page copy is stale. Whichever is newer wins. ---- */
    var seedNode = document.getElementById('hq-split-seed'), seed = seedNode ? json(seedNode.textContent) : null;
    var kept = json(get(local, CONFIG)), cached = kept && kept.shop === shop && kept.cfg && typeof kept.cfg === 'object' ? kept : null;
    var usable = function (c) { return c && typeof c === 'object' && Array.isArray(c.tests) ? c : null; };
    seed = usable(seed);
    var cfg = cached && usable(cached.cfg) && (!seed || (cached.cfg.rev || 0) > (seed.rev || 0)) ? cached.cfg : seed;
    var ask = function (testId, done) {
      request('GET', ENDPOINT + 'split-config?shop=' + encodeURIComponent(shop) + (testId ? '&test=' + testId : ''), null, function (c) {
        c = usable(c);
        if (c && !testId) set(local, CONFIG, JSON.stringify({ shop: shop, got: Date.now(), cfg: c }));
        done(c);
      }, WAIT_MS);
    };

    var started = false, waiting = 0, run;
    var go = function () { if (started) return; started = true; try { run(); } catch (e) { fail('run', e); unhide(); api.ready = true; } };
    var done = function () { if (--waiting <= 0) go(); };

    // A draft whose build passed rides in the page's own copy as preview-only, so a preview is shown at once, with no request, exactly
    // as a shopper would get it. The dashboard is asked first only when the page does not have that test. Otherwise it is asked once the
    // page is up, and when it holds another build of the test than the page showed, the page is loaded once more with that one.
    var previewed = function (c) { var found = null; ((c && c.tests) || []).forEach(function (t) { if (preview && t.id === preview.test) found = t; }); return found; };
    var recheck = false;
    // A tab that is previewing says so, in a small bar of its own that cannot be taken for the store: which test and group, that nothing
    // is counted, and a way out. It sits above whatever the store pins to the bottom of the screen and leaves the top alone. A driven
    // browser (the builder's previews, our checks) is not shown it unless ?hq_bar=1 asks.
    var previewBar = function () {
      if (!preview || (bot && get(session, PREVIEW + '_bar') !== '1') || document.querySelector('[data-hq-bar]')) return;
      var t = previewed(cfg), names = {}, list = (t && t.groups) || [];
      list.forEach(function (g) { names[g.id] = g.n || (g.c ? 'Control' : 'Group ' + g.id.toUpperCase()); });
      var go = function (group) {
        var u = new URL(location.href);
        if (group) u.searchParams.set('hq_preview', preview.test + '.' + group);
        else { u.searchParams.delete('hq_preview'); set(session, PREVIEW, null); set(session, PREVIEW + '_cfg', null); set(session, PRICED, null); }
        location.assign(u.pathname + u.search + u.hash);
      };
      var host = document.createElement('div'); host.setAttribute('data-hq-bar', '');
      host.style.cssText = 'position:fixed;left:8px;right:8px;bottom:8px;z-index:2147483647;display:flex;justify-content:center;pointer-events:none;margin:0;padding:0';
      var root = host.attachShadow ? host.attachShadow({ mode: 'open' }) : host;
      var css = document.createElement('style');
      css.textContent = '.b{pointer-events:auto;box-sizing:border-box;max-width:720px;display:flex;flex-wrap:wrap;align-items:center;gap:6px 10px;padding:8px 10px;border-radius:10px;border:2px solid #fbbf24;background:#111827;color:#fff;font:500 12px/1.35 system-ui,-apple-system,Segoe UI,Roboto,sans-serif;letter-spacing:0;box-shadow:0 6px 24px rgba(0,0,0,.35)}.b b{font-weight:700;color:#fbbf24}.q{opacity:.75}button{all:unset;cursor:pointer;font:600 12px/1 system-ui,-apple-system,Segoe UI,Roboto,sans-serif;padding:6px 9px;border-radius:7px;background:rgba(255,255,255,.14);color:#fff}button.x{background:#fff;color:#111827}button:focus-visible{outline:2px solid #fbbf24}';
      var bar = document.createElement('div'); bar.className = 'b'; bar.setAttribute('role', 'status');
      var add = function (tag, text, cls) { var e = document.createElement(tag); e.textContent = text; if (cls) e.className = cls; bar.appendChild(e); return e; };
      add('b', 'Preview');
      // A link to a test that was deleted, or whose build was dropped, shows the store as it is: the bar says so.
      if (t && names[preview.group]) { add('span', (t.name || 'Test ' + preview.test) + ' \u00b7 ' + names[preview.group]); add('span', 'Not counted. Only this tab.', 'q'); }
      else add('span', 'This test has nothing to show here: it was deleted, or it has not been built. You are seeing the store as it is.');
      list.forEach(function (g) { if (g.id !== preview.group) add('button', 'See ' + names[g.id]).addEventListener('click', function () { go(g.id); }); });
      add('button', 'Exit preview', 'x').addEventListener('click', function () { go(null); });
      root.appendChild(css); root.appendChild(bar);
      // Above whatever the store itself pins to the bottom (a sticky Add to Cart), and again whenever that appears or goes.
      var lift = function () {
        var up = 0;
        try {
          var hit = document.elementsFromPoint(Math.round(window.innerWidth / 2), window.innerHeight - 3);
          for (var i = 0; i < hit.length && !up; i++) for (var n = hit[i]; n && n !== document.body && n !== document.documentElement; n = n.parentElement) {
            if (n === host) break;
            var c = getComputedStyle(n);
            if (c.position === 'fixed' || c.position === 'sticky') { var r = n.getBoundingClientRect(); if (r.bottom >= window.innerHeight - 2 && r.height < window.innerHeight / 2) up = window.innerHeight - r.top; break; }
          }
        } catch (e) {}
        host.style.bottom = (up + 8) + 'px';
      };
      var queued = false, soon = function () { if (queued) return; queued = true; (window.requestAnimationFrame || setTimeout)(function () { queued = false; lift(); }); };
      var mount = function () { if (!document.body || host.parentNode) return; document.body.appendChild(host); lift(); window.addEventListener('scroll', soon, { passive: true }); window.addEventListener('resize', soon); setTimeout(lift, 800); setTimeout(lift, 2500); };
      if (document.body) mount(); else document.addEventListener('DOMContentLoaded', mount);
    };
    var recheckPreview = function () {
      if (!recheck) return;
      var shown = JSON.stringify(previewed(cfg));
      setTimeout(function () {
        ask(preview.test, function (c) {
          if (!c || JSON.stringify(previewed(c)) === shown) return;
          set(session, PREVIEW + '_cfg', JSON.stringify({ test: preview.test, at: Date.now(), cfg: c }));
          try { location.reload(); } catch (e) {}
        });
      }, 1500);
    };
    if (preview) {
      var newer = json(get(session, PREVIEW + '_cfg'));
      if (newer && newer.test === preview.test && Date.now() - newer.at < 600000 && usable(newer.cfg)) cfg = newer.cfg;
      if (previewed(cfg)) recheck = true;
      else { waiting++; ask(preview.test, function (c) { if (c) cfg = c; done(); }); }
    }
    else if (!cfg) { waiting++; ask(null, function (c) { if (c) cfg = c; done(); }); }
    else if (!cached || now - cached.got > REFRESH_MS || now < cached.got) ask(null, function () {});

    // Storage was wiped but Shopify's own cart cookie outlives it: the cart still names this visitor and their groups.
    if (!vid && /(?:^|; )cart=/.test(document.cookie)) {
      waiting++;
      request('GET', root + 'cart.js', null, function (cart) {
        var a = cart && cart.attributes;
        if (a && validId(a._hq_vid) && !vid) { vid = a._hq_vid; var old = parseGroups(a._hq_groups); Object.keys(old).forEach(function (id) { if (!groups[id]) groups[id] = old[id]; }); api.recovered = true; }
        done();
      }, WAIT_MS);
    }

    /* ---- Showing a group ---- */
    var queue = [], flushTimer = 0, tracked = {}, sess = null, observer = null, passes = [], scheduled = false;
    var counting = function () { return !preview && Object.keys(tracked).length > 0; };
    // A report stays in this browser until the dashboard answers that it has it. One that got no answer (the page was left, the
    // network dropped, a blocker cut it) is sent again from the next page; the dashboard counts a visit once however often it hears of it.
    var outbox = function () { var list = json(get(local, OUTBOX)); return Array.isArray(list) ? list.filter(function (b) { return b && b.q && Date.now() - b.q < DAY_MS; }).slice(-12) : []; };
    var forget = function (id) { var list = outbox().filter(function (b) { return b.id !== id; }); set(local, OUTBOX, list.length ? JSON.stringify(list) : null); };
    var keeps = (function () { try { return typeof Request === 'function' && 'keepalive' in Request.prototype; } catch (e) { return false; } })();
    var post = function (body, leaving) {
      // `ts` is this browser's clock at sending, so the dashboard can tell how long ago each event was whatever the clock says.
      body.ts = Date.now();
      var text = JSON.stringify(body), url = ENDPOINT + 'split-collect';
      // While the page is being left no answer can be read; the copy in the outbox is what makes sure. A kept-alive fetch outlives the
      // page where the browser has one. A beacon is the fallback only: blocker lists stop every beacon sent to another site
      // (EasyPrivacy `$ping,3p`, on by default in uBlock Origin and Brave) and let a fetch through.
      if (leaving && !keeps) { try { if (navigator.sendBeacon && navigator.sendBeacon(url, text)) return; } catch (e) {} }
      try {
        (nativeFetch || window.fetch).call(window, url, { method: 'POST', body: text, keepalive: true, mode: 'cors', credentials: 'omit' }).then(function (r) { if (r && r.status >= 200 && r.status < 300) forget(body.id); }, function () {});
      } catch (e) {}
    };
    var flush = function (leaving) {
      clearTimeout(flushTimer);
      if (!queue.length || !counting()) { queue.length = 0; return; }
      var body = { v: 1, id: unit(vid + Date.now() + Math.random()).toString(36).slice(2, 12), q: Date.now(), shop: shop, vid: vid, sid: sess.id, src: 'script', bot: bot ? 1 : 0, int: internal ? 1 : 0, g: tracked,
        ctx: { dev: sess.dev, nw: sess.nw, ch: sess.ch, site: sess.site, us: sess.us, um: sess.um, uc: sess.uc, lp: sess.lp, ref: sess.ref, co: sess.co || '', t: sess.t }, ev: queue.splice(0) };
      var list = outbox(); list.push(body); set(local, OUTBOX, JSON.stringify(list));
      post(body, leaving === true);
    };
    var track = function (name, extra) {
      if (!counting()) return;
      var ev = { n: name, at: Date.now(), p: path.slice(0, 200) }, k;
      for (k in extra || {}) ev[k] = extra[k];
      queue.push(ev);
      clearTimeout(flushTimer); flushTimer = setTimeout(flush, 400);
    };
    // A visitor counts in a test from the first page where the test could show them something.
    var expose = function (entry) {
      var id = entry.test.id;
      if (api.exposed[id]) return;
      api.exposed[id] = entry.group.id;
      // Sent on every page that shows the test; the dashboard keeps the first of a visit.
      if (entry.count) track('x', { t: id, g: entry.group.id });
    };
    var broken = function (entry, where, e) { fail(entry.test.id + ' ' + where, e); track('err', { t: entry.test.id, g: entry.group.id, m: (where + ': ' + String((e && e.message) || e)).slice(0, 120) }); };

    var hide = function (selectors) {
      try {
        if (!selectors.length || !window.CSS || !CSS.supports || !CSS.supports('selector(:is(a))')) return;
        var style = document.createElement('style');
        style.setAttribute('data-hq', 'hide');
        style.textContent = selectors.map(function (s) { return ':is(' + s + '):not([data-hq-done])'; }).join(',') + '{visibility:hidden!important}';
        (document.head || document.documentElement).appendChild(style);
        styles.push(style);
      } catch (e) {}
    };
    var css = function (text, id) { var style = document.createElement('style'); style.setAttribute('data-hq', id); style.textContent = text; (document.head || document.documentElement).appendChild(style); };

    var each = function (selector, fn) { var nodes; try { nodes = document.querySelectorAll(selector); } catch (e) { return 0; } for (var i = 0; i < nodes.length; i++) fn(nodes[i]); return nodes.length; };
    var inserted = function (node, key, where) {
      var near = where === 'before' ? node.previousElementSibling : where === 'after' ? node.nextElementSibling : where === 'prepend' ? node.firstElementChild : node.lastElementChild;
      return !!(near && near.getAttribute && near.getAttribute('data-hq-in') === key);
    };
    var place = function (node, key, where, html) {
      if (inserted(node, key, where)) return;
      var box = document.createElement('template');
      box.innerHTML = html;
      var first = box.content.firstElementChild;
      // Several elements, or words with no element round them, travel in one wrapper that takes up no box of its own.
      if (!first || box.content.childNodes.length > 1) { if (!box.content.childNodes.length) return; var wrap = document.createElement(first ? 'div' : 'span'); wrap.style.display = 'contents'; wrap.appendChild(box.content); first = wrap; }
      first.setAttribute('data-hq-in', key);
      node.insertAdjacentElement(where === 'before' ? 'beforebegin' : where === 'after' ? 'afterend' : where === 'prepend' ? 'afterbegin' : 'beforeend', first);
    };
    // One change on one element. Applied again only when the theme has put the old content back.
    var change = function (node, c, key) {
      var memo = node._hq || (node._hq = {}), a = c.action, v = c.value == null ? '' : String(c.value);
      if (a === 'text') { if (node.textContent !== v) node.textContent = v; }
      else if (a === 'html') { if (memo[key] == null || memo[key] !== node.innerHTML) { node.innerHTML = v; memo[key] = node.innerHTML; } }
      else if (a === 'attr') { if (c.name && node.getAttribute(c.name) !== v) node.setAttribute(c.name, v); }
      else if (a === 'image') { if (node.getAttribute('src') !== v) { node.removeAttribute('srcset'); node.removeAttribute('sizes'); node.setAttribute('src', v); var pic = node.parentNode; if (pic && pic.tagName === 'PICTURE') Array.prototype.forEach.call(pic.querySelectorAll('source'), function (s) { s.parentNode.removeChild(s); }); } }
      else if (a === 'style') { if (!memo[key]) { node.style.cssText += ';' + v; memo[key] = 1; } }
      else if (a === 'class') { v.split(/\s+/).forEach(function (name) { if (!name) return; if (name.charAt(0) === '-') node.classList.remove(name.slice(1)); else node.classList.add(name); }); }
      else if (a === 'hide') { if (node.style.display !== 'none') node.style.setProperty('display', 'none', 'important'); }
      else if (a === 'remove') { if (node.parentNode) node.parentNode.removeChild(node); return; }
      else if (a === 'before' || a === 'after' || a === 'prepend' || a === 'append') place(node, key, a, v);
      else if (a === 'move') { if (!memo[key]) { var target = document.querySelector(c.to); if (!target) return; target.insertAdjacentElement(c.name === 'before' ? 'beforebegin' : c.name === 'prepend' ? 'afterbegin' : c.name === 'append' ? 'beforeend' : 'afterend', node); memo[key] = 1; } }
      if (!node.hasAttribute('data-hq-done')) node.setAttribute('data-hq-done', '');
    };

    // Runs every pass now and again whenever the page changes: the parser adding elements, or the theme redrawing a section.
    var sweep = function () { scheduled = false; for (var i = 0; i < passes.length; i++) { try { passes[i](); } catch (e) { fail('pass', e); } } };
    var watch = function (pass) {
      passes.push(pass);
      if (observer || !window.MutationObserver) return;
      observer = new MutationObserver(function () {
        // While the page is still loading every change is handled before the next paint; afterwards at most once a frame.
        if (document.readyState === 'loading') sweep();
        // A browser that is not painting (a tab behind another) does not run frame callbacks, so a timer stands behind the frame.
        else if (!scheduled) { scheduled = true; var went = false, run = function () { if (!went) { went = true; sweep(); } }; if (window.requestAnimationFrame) window.requestAnimationFrame(run); setTimeout(run, 150); }
      });
      observer.observe(document.documentElement, { childList: true, subtree: true, characterData: true });
      document.addEventListener('DOMContentLoaded', sweep);
    };

    var content = function (entry) {
      var t = entry.test, g = entry.group, changes = g.changes || [], anchors = t.anchors || [], stopped = false;
      if (!matchPath(t.pages, path)) return;
      if (g.css) css(g.css, t.id);
      hide(changes.filter(function (c) { return !/^(before|after|prepend|append)$/.test(c.action); }).map(function (c) { return c.selector; }));
      var pass = function () {
        if (stopped) return;
        try {
          // Counted first: a change can take the very element away that says the test is on this page.
          if (!api.exposed[t.id]) for (var a = 0; a < anchors.length; a++) if (each(anchors[a], function () {})) { expose(entry); break; }
          changes.forEach(function (c, i) { each(c.selector, function (node) { change(node, c, t.id + ':' + i); }); });
        } catch (e) { stopped = true; unhide(); broken(entry, 'change', e); }
      };
      if (!anchors.length) expose(entry);
      if (changes.length || anchors.length) { pass(); watch(pass); }
      if (g.js) {
        var script = function () { try { new Function('test', 'group', g.js)(t, g); } catch (e) { broken(entry, 'js', e); } };
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', script); else script();
      }
    };

    // Leaves the page. A page that keeps sending the visitor round is stopped after three moves in ten seconds.
    var leave = function (href) {
      var log = (json(get(session, LOOP)) || []).filter(function (at) { return Date.now() - at < 10000; });
      if (log.length >= 3) return false;
      log.push(Date.now()); set(session, LOOP, JSON.stringify(log));
      flush();
      css('html{visibility:hidden!important}', 'leave');
      location.replace(href);
      return true;
    };
    var template = function (entry) {
      var t = entry.test, view = entry.group.view;
      if (!t.pages || !t.pages.length || !matchPath(t.pages, path)) return;
      expose(entry);
      if (!view || q.get('view') === view) return;
      var u = new URL(location.href);
      u.searchParams.set('view', view);
      leave(u.href);
    };
    var redirect = function (entry) {
      var t = entry.test, to = entry.group.url, u = to ? new URL(to, location.origin) : null;
      if (!t.pages || !t.pages.length) return;
      // A visitor who was sent on and comes back straight to where they were sent is on a page of the test as well.
      if (u && u.origin === location.origin && normal(u.pathname) === normal(path)) { expose(entry); return; }
      if (!matchPath(t.pages, path)) return;
      expose(entry);
      if (!u || u.origin !== location.origin) return;
      q.forEach(function (value, key) { if (!u.searchParams.has(key)) u.searchParams.set(key, value); });
      leave(u.href);
    };

    // Price tests: the group's amounts replace the product's own wherever the page prints them, and an add to cart takes the group's duplicate variant.
    var swaps = { ids: {}, ready: false };
    var price = function (entry) {
      var t = entry.test, g = entry.group, own = (t.products || []).map(function (p) { return normal('/products/' + p); }), here = own.indexOf(normal(path)) >= 0, seen = false;
      // A duplicate's own page would show the right price but none of the product's other tests; the visitor is sent to the real page.
      var twin = t.twins && t.twins[normal(path).replace(/^\/products\//, '')];
      if (twin && normal(path).indexOf('/products/') === 0) { var u = new URL(location.href); u.pathname = root + 'products/' + twin; if (leave(u.href)) return; }
      // This tab found the cart charging another price than the page showed: it shows the product's own price from then on.
      if (t.fn && fnOff[t.id]) return;
      var maps = g.map ? priceMaps(g.map) : null, swapped = 0, struck = t.fn && g.map ? compareMaps(g.map) : null;
      var ours = function (node) { var row = node.closest('li,tr,[data-cart-item],.cart-item'); return !row || (t.products || []).some(function (h) { return !!row.querySelector('a[href*="/products/' + h + '"]'); }); };
      var scopes = function () {
        if (here || t.everywhere) return [document.body];
        var out = [];
        if (t.scope && t.scope.length) { t.scope.forEach(function (selector) { each(selector, function (box) { out.push(box); }); }); return out; }
        (t.products || []).forEach(function (handle) {
          each('a[href*="/products/' + handle + '"]', function (link) {
            var box = link.closest('[data-product-handle],[data-product-id],article,li,.card,.product-card,section,.shopify-section') || link.parentNode;
            if (box && out.indexOf(box) < 0) out.push(box);
          });
        });
        return out;
      };
      var skip = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, TEXTAREA: 1, TEMPLATE: 1 }, CARTS = '[data-ehq-cart],[data-hq-keep],cart-drawer,cart-notification,.cart-drawer,#CartDrawer,form[action$="/cart"]';
      var pass = function () {
        var boxes = scopes();
        if (boxes.length && boxes[0]) seen = true;
        if (seen) expose(entry);
        if (!maps || maps.clash) return;
        boxes.forEach(function (box) {
          if (!box) return;
          var walker = document.createTreeWalker(box, NodeFilter.SHOW_TEXT, null), node, list = [], crossed = [];
          // The cart is left alone: it prints the price that is charged (the duplicate's own, or the one the function gave the line).
          // With the function only its struck-through compare-at price is still the product's own, and that one is changed.
          while ((node = walker.nextNode())) {
            if (!node.nodeValue || (node.nodeValue.indexOf('$') < 0 && node.nodeValue.indexOf('%') < 0) || node._hqText === node.nodeValue || !node.parentNode || skip[node.parentNode.tagName]) continue;
            if (!(node.parentNode.closest && node.parentNode.closest(CARTS))) list.push(node);
            else if (struck && node.parentNode.closest('s,del,strike') && ours(node.parentNode)) crossed.push(node);
          }
          list.forEach(function (text) { var next = swapText(text.nodeValue, maps); if (next !== text.nodeValue) { text.nodeValue = next; swapped++; api.swapped = (api.swapped || 0) + 1; } text._hqText = next; });
          crossed.forEach(function (text) { var next = swapText(text.nodeValue, struck); if (next !== text.nodeValue) text.nodeValue = next; text._hqText = next; });
          // Themes keep each variant's price in data- attributes and print it on a variant change.
          Array.prototype.forEach.call(box.querySelectorAll('[data-price],[data-compare],[data-saving],[data-compare-price],[data-price-now],[data-price-was]'), function (el) {
            if (el._hqAttrs || (el.closest && el.closest(CARTS))) return; el._hqAttrs = 1;
            Array.prototype.forEach.call(el.attributes, function (attr) { if (/^data-/.test(attr.name) && attr.value.indexOf('$') >= 0) { var next = swapText(attr.value, maps); if (next !== attr.value) el.setAttribute(attr.name, next); } });
          });
        });
        // The cart must never charge a price the page did not show: the variant is swapped only once the page's amounts were.
        if (swapped > 0 && !swaps.ready) {
          swaps.ready = true; Object.keys(maps.ids).forEach(function (id) { if (maps.ids[id] !== id) swaps.ids[id] = maps.ids[id]; });
          // Remembered: this visitor has now been shown this group's price (a preview remembers it for its tab only).
          try { var seen = json(get(preview ? session : local, PRICED)) || {}; if (seen[t.id] !== g.id) { seen[t.id] = g.id; set(preview ? session : local, PRICED, JSON.stringify(seen)); } } catch (e) {}
          // With the function, the cart is told at once which price this browser is shown.
          if (t.fn) { stamped = false; later(0); }
        }
      };
      if (maps && maps.clash) broken(entry, 'price', 'two variants share a price but not the new one');
      pass(); watch(pass);
      if (maps && here) window.addEventListener('load', function () { setTimeout(function () { if (!swapped) broken(entry, 'price', 'no amount on the page matched'); }, 1500); });
    };

    /* ---- The cart: our attributes on it, and a price group's variant in every add ---- */
    var busy = false, themeWrites = 0, cartTimer = 0, waits = 0, check, stamped = false, waiting_ = [], current = [];
    // Pricing tests charged by the store's cart transform function: the cart names the groups whose price this browser has been shown
    // (_hq_px) and the function charges those lines that price. A previewing tab names the group it previews, and nothing else of ours.
    // `pxNow` is null when none of the store's tests is charged that way: the attribute is then not ours to write.
    var FNOFF = 'hq_fnoff', fnOff = json(get(session, FNOFF)) || {};
    // A built draft matters only to a browser that previews (it names the previewed group in its cart, and the next tab that is not
    // previewing takes it out again): a shopper's browser does not read its cart on every page because a draft exists.
    var PXSEEN = 'hq_pxseen';
    var fnAny = function () { return !!(cfg && (cfg.tests || []).some(function (t) { return t.type === 'price' && t.fn && (!t.draft || !!preview || get(local, PXSEEN) === '1'); })); };
    var pxNow = function () {
      if (!fnAny()) return null;
      return money.own ? shownPrices(current.filter(function (e) { return !fnOff[e.test.id]; }), json(get(preview ? session : local, PRICED)) || {}) : '';
    };
    var stamping = function () { return counting() || pxNow() !== null; };
    var attributes = function () { var a = {}, px = pxNow(); if (counting()) { a._hq_vid = vid; a._hq_groups = formatGroups(tracked); } if (px !== null) a._hq_px = px; return a; };
    var carries = function (cart, attrs) { if (!cart || !cart.attributes) return false; for (var k in attrs) if (String(cart.attributes[k] == null ? '' : cart.attributes[k]) !== attrs[k]) return false; return true; };
    var cacheKey = function (attrs) { return (attrs._hq_vid || '') + ' ' + (attrs._hq_groups || '') + (attrs._hq_px == null ? '' : ' ' + attrs._hq_px); };
    // `stamped` is true while the cart is known to carry our attributes. Whoever waits on that is let go as soon as it is known.
    var settle = function (ok, attrs) { stamped = ok; if (ok) set(session, CART, cacheKey(attrs)); waiting_.splice(0).forEach(function (fn) { try { fn(); } catch (e) {} }); };
    // The cart was drawn with another price than it charges now: the drawer is drawn again, and the cart page loaded once more. Each
    // cause keeps its own mark of having reloaded, so one that cannot be put right never reloads the page a second time.
    var redraw = function (mark) {
      try { if (window.EHQCart && window.EHQCart.refresh) window.EHQCart.refresh(); } catch (e) {}
      if (/\/cart\/?$/.test(path) && get(session, mark) !== '1') { set(session, mark, '1'); try { location.reload(); } catch (e) {} }
    };
    // The function is checked against the page on every look at the cart. A line the cart should charge this browser's price and does
    // not (the function did not run, or no longer holds the test) is a fault: it is reported once, and this tab shows the product's own
    // price from then on, which is what the cart charges. Nobody is left looking at a price they would not pay.
    var audit = function (cart) {
      try {
        if (pxNow() === null || !cart || !cart.items) return;
        var wrong = mischarged(cart.items, current.filter(function (e) { return !fnOff[e.test.id]; }), parseGroups(cart.attributes && cart.attributes._hq_px));
        if (!wrong.length) return;
        wrong.forEach(function (w) {
          if (fnOff[w.test]) return;
          fnOff[w.test] = 1; api.fnOff = fnOff;
          fail('function', 'the cart charges ' + w.charged + ', the page shows ' + w.shown);
          track('err', { t: w.test, g: w.group, m: 'function: the cart charges $' + w.charged / 100 + ', the page shows $' + w.shown / 100 });
        });
        set(session, FNOFF, JSON.stringify(fnOff));
        stamped = false; later(0);
        if (get(session, 'hq_fnreload') !== '1') { set(session, 'hq_fnreload', '1'); setTimeout(function () { try { flush(true); location.reload(); } catch (e) {} }, 600); }
      } catch (e) { fail('audit', e); }
    };
    // Runs `fn` once the cart carries the attributes, or after `cap` milliseconds whatever happened: a buyer is never kept waiting on us.
    var ensure = function (fn, cap) {
      if (!stamping() || stamped) return fn();
      var went = false, once = function () { if (!went) { went = true; fn(); } };
      waiting_.push(once); setTimeout(once, cap); later(0);
    };
    // Runs `fn` when no write of ours is on its way. Two requests that each find no cart each make one, and the browser keeps only the last.
    var idle = function (fn) { var tries = 0, look = function () { if (!busy || tries++ > 30) fn(); else setTimeout(look, 50); }; look(); };
    var later = function (ms) { clearTimeout(cartTimer); cartTimer = setTimeout(function () { try { check(); } catch (e) {} }, ms); };
    // Two cart changes sent at once can overwrite each other, so this never writes while another script is changing the cart.
    var clear = function () {
      if (busy || !stamping()) return false;
      if (themeWrites > 0) { if (waits++ < 8) later(500); return false; }
      waits = 0;
      return true;
    };
    var write = function (had) {
      if (!clear()) return;
      busy = true;
      var attrs = attributes();
      request('POST', root + 'cart/update.js', { attributes: attrs }, function (cart) {
        busy = false;
        var ok = carries(cart, attrs);
        settle(ok, attrs);
        // The cart names another price group than a moment ago: what was drawn from it is drawn again, and the charge is looked at.
        if (ok && attrs._hq_px != null && had !== attrs._hq_px) { if (cart.item_count) redraw('hq_pxfix'); if (attrs._hq_px) later(700); }
      });
    };
    check = function () {
      if (!clear()) return;
      busy = true;
      var attrs = attributes();
      request('GET', root + 'cart.js', null, function (cart) {
        busy = false;
        if (cart && carries(cart, attrs)) { settle(true, attrs); if (attrs._hq_px != null) { set(session, 'hq_pxfix', null); audit(cart); } }
        else if (cart) write(String((cart.attributes && cart.attributes._hq_px) || '')); else settle(false, attrs);
      });
    };
    api.sync = function () { later(0); };

    var ADD = /\/cart\/add(\.js)?(\?|$)/, CHANGE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
    var began = function () { themeWrites++; };
    // After any cart change the cart may be a new one (the last became an order), so it is looked at again at once.
    var ended = function (wasAdd, ok) { themeWrites = Math.max(0, themeWrites - 1); stamped = false; if (wasAdd && ok) track('cart'); later(120); };
    // An add names this browser's price group in the cart together with the line (function-priced tests), and takes the group's
    // duplicate variant (tests built with duplicates). The attributes are the same ones the cart is stamped with.
    var addExtra = function () { return pxNow() === null ? null : attributes(); };
    var retold = function (body, extra) { var out = swaps.ready ? swapAdd(body, swaps.ids) : body; return extra ? addAttrs(out, extra) : out; };
    var nativeFetch = window.fetch;
    if (typeof nativeFetch === 'function') window.fetch = function (input, init) {
      var args = arguments, url = '', extra = null;
      try {
        url = typeof input === 'string' ? input : String((input && (input.url || input.href)) || input || '');
        extra = ADD.test(url) ? addExtra() : null;
        if (ADD.test(url) && (swaps.ready || extra) && init && init.body != null) { var copy = {}, k; for (k in init) copy[k] = init[k]; copy.body = retold(init.body, extra); args = [input, copy]; }
      } catch (e) {}
      // An add sent as a ready-made Request has its body read, swapped and sent again.
      var whole = null;
      try { if (ADD.test(url) && (swaps.ready || extra) && !(init && init.body != null) && typeof Request === 'function' && input instanceof Request) whole = input.clone(); } catch (e) {}
      var send = function () { return whole ? whole.text().then(function (text) { return nativeFetch.call(window, new Request(input, { body: retold(text, extra) }), init); }, function () { return nativeFetch.apply(window, args); }) : nativeFetch.apply(window, args); };
      // A cart change of the theme's waits the moment it takes for a write of ours to land (see `idle`).
      var promise = busy && CHANGE.test(url) ? new Promise(function (resolve) { idle(resolve); }).then(send) : send();
      try {
        if (CHANGE.test(url)) {
          var wasAdd = ADD.test(url);
          began();
          promise.then(function (r) { try { ended(wasAdd, !!(r && r.ok)); } catch (e) {} }, function () { try { ended(false, false); } catch (e) {} });
        }
      } catch (e) {}
      return promise;
    };
    var nativeOpen = XMLHttpRequest.prototype.open, nativeSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      try {
        if (!this._hq && CHANGE.test(String(url))) {
          var x = this, wasAdd = this._hqAdd = ADD.test(String(url)); this._hqChange = true;
          this.addEventListener('loadstart', began);
          this.addEventListener('loadend', function () { try { ended(wasAdd, x.status >= 200 && x.status < 300); } catch (e) {} });
        }
      } catch (e) {}
      return nativeOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function (body) {
      var x = this, args = arguments;
      try { if (x._hqAdd && body != null) { var extra = addExtra(); if (swaps.ready || extra) args = [retold(body, extra)]; } } catch (e) {}
      if (busy && x._hqChange) { idle(function () { nativeSend.apply(x, args); }); return; }
      return nativeSend.apply(x, args);
    };
    // A form that posts to /cart/add without script reloads the page. The variant is swapped for the moment the browser reads the form.
    document.addEventListener('submit', function (event) {
      try {
        var form = event.target;
        if (!form || !form.getAttribute || !/\/cart\/add/.test(form.getAttribute('action') || '')) return;
        var field = form.querySelector('[name="id"]');
        if (field && swaps.ready && swaps.ids[field.value]) { var before = field.value; field.value = swaps.ids[before]; setTimeout(function () { field.value = before; }, 0); }
        var extra = addExtra();
        if (extra) Object.keys(extra).forEach(function (k) {
          var name = 'attributes[' + k + ']', input = form.querySelector('input[type="hidden"][name="' + name + '"]');
          if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = name; form.appendChild(input); }
          input.value = extra[k];
        });
      } catch (e) {}
    }, true);

    // Checkout is held for the moment it takes to be sure the cart names this visitor and their groups: the order must carry them.
    var CHECKOUT = /\/checkout(\/|\?|#|$)/;
    document.addEventListener('click', function (event) {
      try {
        if (stamped || !stamping() || event.defaultPrevented || event.button || event.metaKey || event.ctrlKey || event.shiftKey) return;
        var link = event.target && event.target.closest ? event.target.closest('a[href]') : null;
        if (!link || link.target === '_blank' || !CHECKOUT.test(link.getAttribute('href') || '')) return;
        event.preventDefault();
        ensure(function () { location.href = link.href; }, HOLD_MS);
      } catch (e) {}
    }, true);
    document.addEventListener('submit', function (event) {
      try {
        var form = event.target, by = event.submitter;
        if (stamped || !stamping() || !form || form._hqGo || !form.getAttribute) return;
        if (!CHECKOUT.test(form.getAttribute('action') || '') && !(by && by.getAttribute && by.getAttribute('name') === 'checkout')) return;
        event.preventDefault();
        ensure(function () { form._hqGo = true; try { if (form.requestSubmit) form.requestSubmit(by || undefined); else form.submit(); } catch (e) { form.submit(); } }, HOLD_MS);
      } catch (e) {}
    }, true);

    /* ---- Start ---- */
    run = function () {
      if (!vid) { var bytes = new Uint8Array(16); (window.crypto || window.msCrypto).getRandomValues(bytes); vid = newId(Date.now(), bytes); minted = true; }
      api.vid = vid;
      var arrival = { us: q.get('utm_source') || '', um: q.get('utm_medium') || '', uc: q.get('utm_campaign') || '', click: q.has('gclid') || q.has('fbclid') || q.has('ttclid') || q.has('msclkid') };
      var old = json(get(local, SESSION));
      if (sameVisit(old, now, arrival)) { sess = old; sess.l = now; }
      else {
        var refHost = ''; try { refHost = document.referrer ? new URL(document.referrer).hostname : ''; } catch (e) {}
        var from = classify({ us: arrival.us, um: arrival.um, uc: arrival.uc, ref: refHost, host: location.hostname, gclid: q.has('gclid') || q.has('gbraid') || q.has('wbraid'), fbclid: q.has('fbclid'), ttclid: q.has('ttclid'), msclkid: q.has('msclkid') });
        var b = new Uint8Array(16); (window.crypto || window.msCrypto).getRandomValues(b);
        sess = { id: newId(now, b).split('-')[1].slice(0, 12), t: now, l: now, lp: clean(path), ref: clean(refHost), us: clean(arrival.us), um: clean(arrival.um), uc: clean(arrival.uc), ch: from.ch, site: from.site,
          // New means this browser had never been seen before this visit began.
          nw: minted ? 1 : 0, dev: /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent || '') || (navigator.maxTouchPoints > 1 && /Macintosh/.test(navigator.userAgent || '')) ? 'm' : 'd' };
      }
      api.session = sess;
      if (!preview) set(local, SESSION, JSON.stringify(sess));
      var tests = (cfg && cfg.tests) || [];
      var needsCountry = !sess.co && tests.some(function (t) { return !groups[t.id] && !t.all && !t.draft && t.tg && t.tg.countries && t.tg.countries.length; });
      if (!needsCountry) return assign(tests);
      // Shopify's own answer to "which country is this visitor in".
      request('GET', root + 'browsing_context_suggestions.json', null, function (r) {
        try { sess.co = String(r.detected_values.country.handle || '').toUpperCase().slice(0, 2); if (!preview) set(local, SESSION, JSON.stringify(sess)); } catch (e) {}
        try { assign(tests); } catch (e) { fail('assign', e); unhide(); api.ready = true; }
      }, 1500);
    };

    // The storefront's currency on this page; `rate` is 1 while it is the shop's own. A pricing test's amounts and its duplicates' prices
    // are in the shop's currency, so on a page in another currency a pricing test shows and counts nothing.
    var money = (function () { try { var c = window.Shopify && window.Shopify.currency; return { active: String((c && c.active) || '').toUpperCase(), own: !c || !c.rate || Number(c.rate) === 1 }; } catch (e) { return { active: '', own: true }; } })();

    // The cart agrees with what this browser is shown. A line that is the product's own variant, or another group's duplicate, becomes
    // this browser's variant of that product: its group's duplicate while a pricing test shows it one (also a group being previewed),
    // and the product's own variant when the test has ended, is paused, or does not have this visitor. So an item added before a test
    // began takes the group's price, nobody checks out at a test's price after the test is over, and an add made while previewing does
    // not stay in the cart. Quantities and line properties are kept. When the cart refuses, the line stays as it is and the fault is kept.
    var cartFix = function (entries) {
      var want = {}, origin = {}, back = (cfg && cfg.back) || {}, d, priced = null;
      for (d in back) origin[String(d)] = String(back[d]);
      // A function-priced test has no duplicate: its variants name themselves, and there is no line to move.
      ((cfg && cfg.tests) || []).forEach(function (t) { if (t.type === 'price') (t.groups || []).forEach(function (g) { for (var o in (g.map || {})) if (String(g.map[o].v) !== String(o)) origin[String(g.map[o].v)] = String(o); }); });
      // A line takes the group's variant only once this visitor has been shown the group's price, on this page or an earlier one: nobody
      // is charged a price no page showed them.
      var hold = {}, shown = json(get(preview ? session : local, PRICED)) || {};
      entries.forEach(function (e) { if (e.test.type === 'price' && !e.test.fn && e.group.map && money.own) { priced = e; for (var o in e.group.map) { if ((swaps.ready && swaps.ids[o]) || shown[e.test.id] === e.group.id) want[String(o)] = String(e.group.map[o].v); else hold[String(o)] = 1; } } });
      if (!Object.keys(origin).length || !/(?:^|; )cart=/.test(document.cookie)) return;
      var fault = function (what) { fail('cart', what); if (priced && counting()) track('err', { t: priced.test.id, g: priced.group.id, m: ('cart: ' + what).slice(0, 200) }); };
      // The cart page was drawn by the server with the old line: it is loaded once more (see `redraw`).
      var done = function () { api.cartFixed = (api.cartFixed || 0) + 1; redraw('hq_cartfix'); };
      request('GET', root + 'cart.js', null, function (cart) {
        var plan = cartPlan(cart && cart.items, want, origin, hold);
        if (!plan.any) { set(session, 'hq_cartfix', null); return; }
        // One line after another, never two cart writes at once. Added first, removed after: a cart that refuses the new line keeps the
        // old one. A line already added on an earlier page (the removal had failed) is only removed.
        var added = json(get(session, 'hq_swap')) || {}, at = 0;
        var next = function () {
          var line = plan.moves[at++];
          if (!line) return done();
          var remove = function () { request('POST', root + 'cart/change.js', { id: line.key, quantity: 0 }, function (r) { if (!r) fault('a replaced line could not be taken out'); else { delete added[line.key]; set(session, 'hq_swap', JSON.stringify(added)); } next(); }, 8000); };
          if (added[line.key]) return remove();
          var item = { id: Number(line.id), quantity: line.quantity, properties: line.properties }; if (line.plan) item.selling_plan = line.plan;
          request('POST', root + 'cart/add.js', { items: [item] }, function (r) { if (!r) { fault('a line could not be changed to the price this visitor is shown'); return next(); } added[line.key] = 1; set(session, 'hq_swap', JSON.stringify(added)); remove(); }, 8000);
        };
        next();
      }, 4000);
    };

    var assign = function (tests) {
      var running = {}, entries = [], shut = {}, byId = {};
      var real = function (id) { return !!groups[id] && groups[id] !== '0'; };
      sess.cur = money.active;
      // Mutually exclusive tests: a visitor is in at most one test of a pair. A group already held always stays and shuts its partners
      // (a paused partner too). The tests still open to this visitor are tried in an order drawn from their ID; the first that takes
      // them shuts the rest. A visitor shut out of a test is shown nothing of it and is not counted in it.
      var sets = tests.filter(function (t) { byId[t.id] = t; return t.ex && t.ex.length && !t.all && !t.draft; });
      sets.forEach(function (t) { if (!real(t.id) && t.ex.some(real)) shut[t.id] = 1; });
      drawOrder(vid, sets.filter(function (t) { return !groups[t.id] && !shut[t.id]; }).map(function (t) { return t.id; })).forEach(function (id) {
        var t = byId[id];
        if (shut[id] || (preview && preview.test === id) || (t.type === 'price' && (!money.own || listed)) || !eligible(t.tg, sess)) return;
        var g = pick(vid, t);
        if (g) { groups[id] = g; t.ex.forEach(function (other) { if (!real(other)) shut[other] = 1; }); }
      });
      tests.forEach(function (t) {
        var forced = preview && preview.test === t.id, g;
        running[t.id] = 1;
        if (t.type === 'price' && !money.own) return;
        if (forced) g = preview.group;
        else if (t.all) g = t.all;
        else if (t.draft) return;
        else if (listed && t.type === 'price' && !given[t.id]) { groups[t.id] = '0'; return; }   // '0' is no group: the product's own price, and not counted
        else if (shut[t.id]) return;
        else if (groups[t.id]) g = groups[t.id];
        else if (eligible(t.tg, sess)) { g = pick(vid, t); if (g) groups[t.id] = g; }
        var group = null;
        (t.groups || []).forEach(function (x) { if (x.id === g) group = x; });
        if (!group) return;
        var count = !forced && !t.all && !t.draft;
        if (count) tracked[t.id] = group.id;
        entries.push({ test: t, group: group, count: count });
      });
      // A group is forgotten only when the dashboard says its test has ended. A copy of the tests that merely lacks one (a page kept
      // from before the test began) must not put a visitor back in the draw.
      if (cfg && !preview) (cfg.gone || []).forEach(function (id) { if (!running[id]) delete groups[id]; });
      api.groups = groups; api.active = entries.map(function (e) { return { test: e.test.id, group: e.group.id, type: e.test.type, counted: e.count }; });
      current = entries; api.px = pxNow;
      if (preview && entries.some(function (e) { return e.test.type === 'price' && e.test.fn; })) set(local, PXSEEN, '1');
      keepIds();
      setTimeout(unhide, HIDE_MS);
      entries.forEach(function (entry) {
        try { ({ content: content, template: template, redirect: redirect, price: price }[entry.test.type] || function () {})(entry); } catch (e) { unhide(); broken(entry, 'start', e); }
      });
      var fixCart = function () { setTimeout(function () { try { cartFix(entries); } catch (e) { fail('cart', e); } }, 700); };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fixCart); else fixCart();
      if (counting()) {
        track('page');
        if (/\/products\//.test(path)) track('product');
        // Reports this browser never got an answer for.
        outbox().forEach(function (b) { if (b.vid === vid && Date.now() - b.q > 4000) post(b, false); });
      }
      if (stamping()) {
        // The cart is stamped as soon as the page has been read, and only when this is not what it already holds. Other scripts that
        // write to the cart as the page loads are seen and waited for (see `clear`). With a function-priced test the cart is always
        // read: another tab (a preview, say) may have named another price group in it since.
        stamped = pxNow() === null && get(session, CART) === cacheKey(attributes());
        var stamp = function () { if (!stamped) later(300); };
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', stamp); else stamp();
      }
      window.addEventListener('pagehide', function () { flush(true); });
      api.ready = true;
      recheckPreview();
      try { previewBar(); } catch (e) { fail('bar', e); }
      try { document.dispatchEvent(new CustomEvent('hq:split', { detail: api })); } catch (e) {}
    };

    if (!waiting) go();
    setTimeout(go, WAIT_MS + 200);
  } catch (e) { unhide(); try { if (window.HQSplit) { window.HQSplit.ready = true; window.HQSplit.errors.push('start: ' + String((e && e.message) || e).slice(0, 160)); } } catch (x) {} }
})();
